;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = require("axios");

var _axios2 = _interopRequireDefault(_axios);

var _xlsx = require("xlsx");

var _xlsx2 = _interopRequireDefault(_xlsx);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ["item"],
  data: function data() {
    return {
      parsedItem: {},
      name: "Excel"
    };
  },
  mounted: function mounted() {
    this.parsedItem = JSON.parse(this.item);
    this.name = this.$attrs["name"];
  },

  methods: {
    download_report: async function download_report() {
      var resp = await _axios2.default.post("/api/download/child/settlements", {
        item: this.parsedItem
      });
      var data = resp.data.content;
      var worksheet = _xlsx2.default.utils.json_to_sheet(data);
      var workbook = _xlsx2.default.utils.book_new();
      _xlsx2.default.utils.book_append_sheet(workbook, worksheet, "Settlement Items");
      var excelBuffer = _xlsx2.default.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      var filename = "settlement_items_" + new Date().toISOString().replace('T', '-').replace('Z', '') + ".xlsx";
      var mimeType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      var blob = new Blob([excelBuffer], { type: mimeType });
      var url = window.URL.createObjectURL(blob);

      var link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-outline-success btn-sm",on:{"click":_vm.download_report}},[_c('span',{staticClass:"iconify",attrs:{"data-icon":"fa:file-excel-o","data-inline":"false"}}),_vm._v("\n  "+_vm._s(this.name)+"\n")])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-25a119dd", __vue__options__)
  } else {
    hotAPI.reload("data-v-25a119dd", __vue__options__)
  }
})()}